import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"

/** Modules */
import Audit from "@hub/audit/src/store/Audit"
import Auth from "@hub/authentication/src/store/"
import Home from "@hub/home/src/store"
import Interface from "@hub/core/src/store/Interface"
import Core from "@hub/core/src/store/Core"
import Management from "@hub/management/src/store/Management"
import Opportunity from "@hub/opportunity/src/store"
import Order from "@hub/order/src/store"
import OfflineOrder from "@hub/offline-order/src/store"
import Report from "@hub/reports/src/store"
import Routes from "@hub/routes/src/store"
import Scheduling from "@hub/scheduling/src/store/Scheduling"
import Settings from "@hub/settings/src/store"
import Simulator from "@hub/simulator/src/store"
import Survey from "@hub/surveys/src/store"

import Visit from "@hub/visit/src/store"
import ExportCenter from "@hub/export-center/src/store"
import Plan from "@hub/plan/src/store"
import TermsOfUse from "@hub/term-of-use/src/store"
import Coverage from "@hub/coverage/src/store"
import Enps from "@hub/enps/src/store"
import Tenant from "@hub/tenant/src/store"
import Lead from "@hub/leads/src/store"

import Dashboard from "@hub/dashboard/src/store"

Vue.use(Vuex)

const vueLocalStorage = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: state => {
    const keys = Object.keys(state).filter(key => key != "loadingScreen")

    const stateSaved = keys.reduce(
      (accumulator, currentValue) => ({
        ...accumulator,
        [currentValue]: state[currentValue]
      }),
      {}
    )

    return stateSaved
  }
})

const Store = new Vuex.Store({
  modules: {
    Audit,
    Auth,
    Home,
    Interface,
    Core,
    Management,
    Opportunity,
    Order,
    OfflineOrder,
    Report,
    Routes,
    Scheduling,
    Settings,
    Simulator,
    Survey,
    Visit,
    ExportCenter,
    Plan,
    TermsOfUse,
    Coverage,
    Enps,
    Tenant,
    Lead,
    Dashboard
  },

  plugins: [vueLocalStorage.plugin]
})

export default Store
